<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">账户名称：</span>
        </div>
        <el-input v-model="formData.aliAccountName" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">支付宝账号：</span>
        </div>
        <el-input v-model="formData.aliAccountNo" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">联系人：</span>
        </div>
        <el-input v-model="formData.contact" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">联系电话：</span>
        </div>
        <el-input v-model="formData.phone" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" type="textarea" :rows="3" size="small" style="width: 280px" />
      </div>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../../components/Text/TextTitle'
import ButtonCancel from '../../../../components/Button/ButtonCancel'
import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
import {api} from '../../../api/ConfigAli'
import {errorHandler} from '../../../../utils/errorHandler'
import {nSuccess} from '../../../../utils/notice'

export default {
  components: {
    ButtonConfirm,
    ButtonCancel,
    TextTitle,
    Breadcrumb},
  name: 'ali-modify',
  data () {
    return {
      breadcrumb: [{
        value: '资源中心',
        name: 'housing-management'
      }, {
        value: '配置管理',
        name: 'ali-config'
      }, {
        value: '支付宝账户配置'
      }],
      mainTitle: '修改支付宝账户',
      subheading: '',
      formData: {
        code: '',
        aliAccountName: '',
        aliAccountNo: '',
        contact: '',
        phone: '',
        memo: ''
      },
      currentCode: ''
    }
  },
  created () {
    this.currentCode = this.$route.params.id
    this.getAliAccountByCode()
  },
  methods: {
    goToAliConfig () {
      this.$router.push({
        name: 'ali-config'
      })
    },
    getAliAccountByCode () {
      this.$axios.get(`${api.getAliAccountByCode}/${this.currentCode}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.formData = res.data.data
          }
        })
        .catch(errorHandler('查询支付宝账户失败'))
    },
    confirm () {
      this.formData.code = this.currentCode
      this.$axios.post(api.updateAliAccount, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.goToAliConfig()
          }
        })
        .catch(errorHandler('添加失败'))
    },
    cancel () {
      this.goToAliConfig()
    }
  }
}
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: -webkit-baseline-middle;
  }
  .form-line {
    margin: 20px 0;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/ConfigurationManagement/ConfigAli/AliModify.vue